import { createContext } from 'react'

export const DropdownMenuContext = createContext({ closeMenu: () => {} })
